import $ from 'jquery';
import 'slick-carousel';

let $tabs;

function loadImages(id) {
  const $images = $(`#${id} img`);
  let imagesLoaded = 0;

  $images.each((i, el) => {
    const $image = $(el);
    const src = $image.attr('data-src');
    if (src) {
      $image
        .attr('src', src)
        .removeAttr('data-src')
        .on('load', function() {
          imagesLoaded++;

          if ($images.length / 2 > 5 && imagesLoaded === $images.length) {
            // only enable carousel if more than 5 items and all images have loaded
            enableCarousel(id);
          }
        });
    }
  });
}

function enableTabs(e) {
  const active = 'is-active';
  const $this = $(e.target);

  $tabs.removeClass(active);
  $this.addClass(active);

  loadImages($this.data('tab'));
  $('.product-container').addClass('is-hidden');
  $(`#${$this.data('tab')}`).removeClass('is-hidden');
}

function enableCarousel(id) {
  const $carouselContainer = $(`#${id} .product-row`);

  if (!$carouselContainer.hasClass('slick-initialized')) {
    $carouselContainer.slick({
      slidesToShow: 5
    });

    return false;
  }

  return true;
}

function events() {
  // hover image
  $('.hover-img').hover(
    e => {
      $(e.target).addClass('fade-out');
    },
    e => {
      $(e.target).removeClass('fade-out');
    }
  );

  $tabs.on('click', enableTabs);
}

function render(config, data) {
  const component = data.component;
  const tabs = component.tabs;

  tabs.forEach(tab => {
    tab.id = `${config.id}-${tab.title
      .replace(/[^a-zA-Z]/g, '')
      .toLowerCase()}`;

    tab.button.id = config.id;

    tab.products.forEach(product => {
      product.price = config.currency + product.price;
      product.quickBuyTxt = config.quickBuyTxt;

      if (!isNaN(product.was) && product.was !== '') {
        product.was = config.currency + product.was;
      }
    });
  });

  const template = require('@template/tabbed-product');
  const html = template(component);

  $(`#${config.id}`).html(html);

  const firstTabId = tabs[0].id;

  $(`[data-tab=${firstTabId}]`).addClass('is-active');
  $(`#${firstTabId}`).removeClass('is-hidden');

  $tabs = $('.c-tabbed-spotlight__tab');

  loadImages(firstTabId);

  events();
}

function getJSON(config) {
  $.get(config.json, data => {
    render(config, data);
  });
}

module.exports.init = function(selector) {
  $(selector).each((i, el) => {
    const $this = $(el);
    const config = $this.data('config');

    config.id = $this.attr('id');

    getJSON(config);
  });
};



// WEBPACK FOOTER //
// ./src/js/product-spotlight.js